// 批量注册指令

// el-radio-group 单选框radio 无障碍性 指令
const removeAria = (el) => {
    var ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
};

const directives = {
	removeAria,
	
};

export default {
  install(Vue) {
      Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
